import React, { useState } from "react";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import { handlePostRequest } from "../../services/PostTemplate";
import * as Yup from "yup";
import { InputText } from "primereact/inputtext";
import { useHistory } from "react-router-dom";

const SearchAccountNumber = ({ api, handleReturnData, title }) => {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("");

    let history = useHistory();

    const validationSchema = Yup.object().shape({
        MobileNo: Yup.string().required("This field is required.").min(11).max(11),
        CnicNumber: Yup.string().required("This field is required.").min(13).max(13),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            MobileNo: "",
            CnicNumber: "",
        },
        onSubmit: async (data) => {
            try {
                setloading(true);
                setloadingIcon("pi pi-spin pi-spinner");

                const res = await handlePostRequest(data, api);
                handleReturnData(res, data);
            } catch (error) {
                console.log('error', error)
                if (error.response.data.messages === "User not found" || error.response.data.messages === "Cnic does not match")
                    handleReturnData(undefined);
            }
            finally {
                setloading(false);
                setloadingIcon("pi pi-save");
            }
        },
    });
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };
    return (
        <div>
            <div className="page_header">
                <div className="Top__Btn" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div className="d_align">
                        <i className="pi pi-arrow-circle-left mr-1" onClick={() => history.goBack()} />
                        <h3 className="mod_heading">{title}</h3>
                    </div>
                </div>
            </div>
            <div className="card Card__Round">
                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                    <div className="p-fluid p-formgrid p-grid">
                        <div className="p-field p-col-12 p-md-6">
                            <div className="p-field input_cp">
                                <label htmlFor="MobileNo" className={classNames({ "p-error": isFormFieldValid("MobileNo") }, "Label__Text")}>
                                    Mobile Number<span className="Label__Required">*</span>
                                </label>
                                <InputText id="MobileNo" placeholder="" name="MobileNo" value={formik?.values?.MobileNo} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("MobileNo") }, " input_text")} keyfilter={/^[0-9]+$/} />

                                {getFormErrorMessage("MobileNo")}
                            </div>
                        </div>

                        <div className="p-field p-col-12 p-md-6">
                            <div className="p-field input_cp">
                                <label htmlFor="CnicNumber" className={classNames({ "p-error": isFormFieldValid("CnicNumber") }, "Label__Text")}>
                                    CNIC<span className="Label__Required">*</span>
                                </label>
                                <InputText id="CnicNumber" placeholder="" name="CnicNumber" value={formik?.values?.CnicNumber} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("CnicNumber") }, " input_text")} keyfilter={/^[0-9]+$/} />

                                {getFormErrorMessage("CnicNumber")}
                            </div>
                        </div>
                    </div>

                    <div className="GenerateDown__Btn p-mt-4">
                        <Button disabled={loading} label={"Search"} className="Btn__Transparent" type="submit" />
                    </div>
                </form>
            </div>
        </div>
    );
};

export default SearchAccountNumber;
